import { getServer } from "@translations/next";
import WellnessContainer from "@containers/WellnessContainer";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import WrapperProvider from "@providers/WrapperProvider";
import _ from "lodash";
import Layout from "@components/Layout";
import StrapiService from "@services/StrapiService";
import StoryArticleService from "@services/StoryArticleService";
import OfferService from "@services/OfferService";
import FooterService from "@services/FooterService";

export default function View(props: any) {
  return (
    <WrapperProvider
      pageContext={{
        ...props,
        pageData: {
          ...props.pageData,
          WellbeingCentre: props.wellbeingPageData,
          Facilities: props.facilitiesPageData,
        },
      }}
    >
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <WellnessContainer />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}

// export { getServerSideProps };
export const getServerSideProps = getServer(async ({ params }: any) => {
  const locale: any = _.get(params, "locale", "en");
  StrapiService.set("id", "hotel10-wellbeing-centre");
  const res = await StrapiService.find({ populate: "deep", locale });
  StrapiService.set("id", "hotel10-facilities-page");
  const resFacilities = await StrapiService.find({ populate: "deep", locale });
  StrapiService.set("id", "hotel10-stay-connected");
  const resPage = await StrapiService.find({
    populate: "deep",
    locale,
  });
  const resStoryArticles = await StoryArticleService.find({
    filters: {
      category: {
        slug: {
          $eq: "wellness",
        },
      },
      hotels: {
        slug: {
          $eq: "amanaki-thao-dien",
        },
      },
    },
    page: 1,
    pageSize: 3,
    populate: "deep",
    locale,
  });
  const resOffer = await OfferService.find({
    filters: {
      category: {
        slug: {
          $eq: "wellness",
        },
      },
      hotel: {
        slug: {
          $eq: "amanaki-thao-dien",
        },
      },
    },
    page: 1,
    pageSize: 2,
    populate: "deep",
    locale,
  });
  const footerData = await FooterService.fetchByHotel("amanaki-thao-dien", locale);
  return {
    hotel: "amanaki-thao-dien",
    pageData: {
      stayConnected: _.get(resPage, "data", {}),
      metatags: _.get(res, "data.attributes.metatags", {}),
    },
    wellbeingPageData: _.get(res, "data", {}),
    facilitiesPageData: _.get(resFacilities, "data", {}),
    storyArticles: _.get(resStoryArticles, "data", []),
    offers: _.get(resOffer, "data", []),
    footerData,
  };
});
